/**
 * Created by wxb on 2023/07/21.
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Carousel, Button } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
class index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            carouselNext: 0,

        };
        this.carouselref = React.createRef();
    }
    componentDidMount() {
        let data = document.querySelectorAll(".slick-dots button");
        data.forEach((it, idx) => {
            if (idx === 0) {
                it.innerHTML = "产线工艺质量应用"
            } else if (idx === 1) {
                it.innerHTML = "产线设备管理提升"
            } else if (idx === 2) {
                it.innerHTML = "产线数据节能"
            }
        });
    }
    afterChangeCarousel = (current) => {
        console.log(current);
        this.setState({ carouselNext: current })
    }
    render() {
        const { carouselNext } = this.state;
        const contentStyle = {
            height:carouselNext===0?'1874px':"1007px",
            color: '#fff',
            lineHeight: carouselNext===0?'1874px':"1007px",
            textAlign: 'center',
            // background: '#fff',
            padding: "90px 260px 24px 260px",
            display: "flex"
        };
        const {
            match: { path },
            location: { pathname },
        } = this.props;
        return (
            <>
                <div style={{background:"#F5F7FA"}}>
                    <div style={{ height: 88 }}></div>
                    <div className="zgh-classicCases-card" style={{ height: 'unset',background:"#F5F7FA" }} >
                        <p className="zgh-menu-title" style={{paddingTop:73}}>经典案例</p>
                        <div>
                            <Carousel ref={this.carouselref} afterChange={this.afterChangeCarousel} dotPosition={"top"} >
                                <div >
                                    <div style={contentStyle} >
                                        <div>
                                            <div style={{ display: "flex" }}>
                                                <div className="zgh-classicCases-leftDescribe">
                                                    <div className="zgh-classicCases-title">湛江钢铁厚板厂超声波探伤缺陷智能应用系统</div>
                                                    <div className="zgh-classicCases-describe">基于厚板产线对超声波探伤信息、剪切组板信息、离线探伤信息，实现板坯的内部质量缺陷回溯，并结合炼钢厂的生产过程数据，通过数据融合、数据回溯等技术，实现钢板内部缺陷向连铸板坯的位置映射，支撑连铸产线快速准确锁定产生异常，支持其降低内部缺陷发生率。通过多工序一贯联动优化板坯成品质
                                                        量，最终提升厚板整体产品合格率。</div>
                                                </div>
                                                <div className="zgh-classicCases-rightPic"></div>
                                            </div>
                                            <div style={{ display: "flex", marginTop: 40 }}>
                                                <div className="zgh-classicCases-leftPic"></div>
                                                <div className="zgh-classicCases-rightDescribe">
                                                    <div className="zgh-classicCases-title">热轧质量模型类质量异常自动分析</div>
                                                    <div className="zgh-classicCases-describe">以热轧产线数据治理、数字孪生钢卷为基础数据底座，从质量缺陷的自动分析为切入点，以分析效率提高、及时改进为抓手，实现产线钢卷质量临时封锁的“卷卷清”。通过规律总结，优化控制过程，实现返修率和废次降率的降低，加快产品流转速度，节约生产成本，通过更好的产品质量，满足客户需求和后道工序的要求。</div>
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", marginTop: 40 }}>
                                                <div className="zgh-classicCases-leftDescribe">
                                                    <div className="zgh-classicCases-title">冷轧C122机组机械性能检测装置深度挖掘和处理</div>
                                                    <div className="zgh-classicCases-describe">通过对C122机组现有部分核心数据的深度开发，实现在线卷在线性能检测数据和工艺数据对应性趋势的展示；对标机械性能检测装置在线检测数据和检化验离线检测结果,形成新钢种在线性能相关检测参数的推荐和老钢种参数优化功能。满足新拓展产品工艺需求，提升超高强钢的生产能力。</div>
                                                </div>
                                                <div className="zgh-classicCases-rightPic leftPic-003"></div>
                                            </div>
                                            <div style={{ display: "flex", marginTop: 40 }}>
                                                <div className="zgh-classicCases-leftPic leftPic-004"></div>
                                                <div className="zgh-classicCases-rightDescribe">
                                                    <div className="zgh-classicCases-title">连铸4CC状态与铸坯质量相关性研究</div>
                                                    <div className="zgh-classicCases-describe">4CC:将连铸机按设备功能逐层解构到最小设备功能单元，并通过对最小单元测点特征值的提取，建立细化的动态功能精度控制标准， 利用系统工具将精度标准配置进系统，在线监测其动态变化，超限报警。构建连铸机设备健康度评价体系，设备系统按功能组成逐层分解至功能精度，通过底层精度的评价打分规则及其各层各项的权重配置，形成从底层基础分值逐层堆叠形成最终整体评价。</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={contentStyle}>
                                        <div>
                                            <div style={{ display: "flex" }}>
                                                <div className="zgh-classicCases-leftDescribe">
                                                    <div className="zgh-classicCases-title">2CC连铸状态智能监控技术研究</div>
                                                    <div className="zgh-classicCases-describe">“2CC连铸状态智能监控技术研究”通过数据采集与OT数据治理、数字孪生铸坯、知识中心、多专业应用体系等系列功能，系统性地将连铸相关的操作、工艺、设备管理的各种数据与应用勾连起来，为连铸相关知识的快速迭代，铸机远程运维，以及操作、工艺优化提供平台、创造条件。</div>
                                                </div>
                                                <div className="zgh-classicCases-rightPic1"></div>
                                            </div>
                                            <div style={{ display: "flex", marginTop: 40 }}>
                                                <div className="zgh-classicCases-leftPic1"></div>
                                                <div className="zgh-classicCases-rightDescribe">
                                                    <div className="zgh-classicCases-title">1880热轧设备健康度评价与设备典型异常监测预警</div>
                                                    <div className="zgh-classicCases-describe">以1880热轧大数据采集和治理为基础，以产线工程师的经验为核心，采用数据应用方式提取数据特征，运用多维分析方法辅助经验提炼和验证经验并形成规则模型；通过对设备功能精度的全要素数字化，基于设备功能精度静态特征管理和动态特性分析，实现设备健康度实时监测和预警；进一步结合轧钢工艺要求、模型设定、生产操作、来料情况和产品质量评估精轧轧制稳定性，实现生产稳定性的智能监测和预警。</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={contentStyle}>
                                        <div>
                                            <div style={{ display: "flex" }}>
                                                <div className="zgh-classicCases-leftDescribe">
                                                    <div className="zgh-classicCases-title">无缝工业炉智能状态监控及诊断应用系统</div>
                                                    <div className="zgh-classicCases-describe">以无缝7座工业炉L1和L2数据采集和治理为基础，通过采用大数据分析技术对数据特征提取与管理，有效分析工艺、操作、设备等耦 合因子对无缝工业炉能耗的影响，开发基于无缝工业炉燃烧状态管理、能耗优化控制精度和操作异常自动预警、性能评价的智能模型，实现无缝工业炉状态智能分析系统集成。</div>
                                                </div>
                                                <div className="zgh-classicCases-rightPic2"></div>
                                            </div>
                                            <div style={{ display: "flex", marginTop: 40 }}>
                                                <div className="zgh-classicCases-leftPic2"></div>
                                                <div className="zgh-classicCases-rightDescribe" style={{padding:"48px 48px 0px 48px"}}>
                                                    <div className="zgh-classicCases-title">1880产线智能节能生产模式技术研究 ISA</div>
                                                    <div className="zgh-classicCases-describe">快速在热轧厂1880产线，通过智能节能数据化应用技术开发，对产线能耗及其相关过程数据、生产实绩数据、钢卷质量结果数据的汇聚、梳理形成数据应用的基础。分别对热轧的燃耗、电耗建模分析、制定不同工况下燃耗、电耗的分摊规则，在线监测每个钢卷能耗，并将燃耗、电耗按品种规格合理分摊到每一个钢卷。<br />
                                                        通过不同品种、规格钢卷燃耗、电耗数据的样本分类收集、分析总结、 特征提取，制定各层别热卷的燃耗、电耗标准。在线监测及时发现异常， 支持根因定位与措施采取，辅助闭环管控，实现能耗的精细化管理。根据预排日计划排程、轧钢节奏模型和基准能耗数据预测预排程的能耗水平， 在保证正常生产和质量的前提下，降低能耗。同时按宝钢现行标准将能耗转换成碳排放，从而提高碳排放的管控水平，助力绿色低碳发展。</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(index)
